import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-plaintext',
    template: `<div>
		<ng-container #fieldComponent></ng-container>
	</div>`,
    standalone: true,
})
export class PlainTextWrapperComponent extends FieldWrapper {}
